import "core-js/stable";
import React from "react";
import ReactDOM from "react-dom";
import Root from "./router/Root";
import { clearRefreshToken } from "libs/task";

import "normalize.css";
import "./index.css";
import "./libs/track";
import "./libs/sendataTrack";
import { attachEventListeners } from "libs/trackClick";

attachEventListeners();

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
// 清楚缓存的refreshToken
clearRefreshToken();
